import $ from 'jquery';
import React from 'react';

type Props = {
  theme?: string,
  font?: string,
  accentColor?: string,
  uiSize?: string,
  children?: React.ReactNode
};

class Root extends React.Component<Props> {
  override componentDidMount (): void {
    const theme: string = this.props.theme ?? '';

    if (theme !== '') {
      $('body').addClass('esko_theme_' + theme);
    }

    const font: string = this.props.font || 'default';
    if (font !== 'default') {
      $('body').addClass('esko_font_' + font);
    }
    const uiSize: string = this.props.uiSize || 'normal';
    if (uiSize !== 'normal') {
      $('body').addClass('esko_ui_' + uiSize);
    }

    const accentColor: string = this.props.accentColor || 'eskogreen';
    if (accentColor !== 'eskogreen') {
      $('body').addClass('esko_accentcolor_' + accentColor);
    }
  }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    const oldTheme: string = prevProps.theme ?? '';
    const newTheme: string = this.props.theme ?? '';
    if (newTheme !== oldTheme) {
      if (oldTheme !== '') {
        $('body').removeClass('esko_theme_' + oldTheme);
      }

      if (newTheme !== '') {
        $('body').addClass('esko_theme_' + newTheme);
      }
    }

    const oldFont: string = prevProps.font || 'default';
    const newFont: string = this.props.font || 'default';

    if (oldFont !== newFont) {
      if (oldFont !== 'default') {
        $('body').removeClass('esko_font_' + oldFont);
      }
      if (newFont !== 'default') {
        $('body').addClass('esko_font_' + newFont);
      }
    }

    const oldUISize: string = prevProps.uiSize || 'normal';
    const newUISize: string = this.props.uiSize || 'normal';

    if (oldUISize !== newUISize) {
      if (oldUISize !== 'normal') {
        $('body').removeClass('esko_ui_' + oldUISize);
      }
      if (newUISize !== 'normal') {
        $('body').addClass('esko_ui_' + newUISize);
      }
    }

    const oldAccentColor: string = prevProps.accentColor || 'eskogreen';
    const newAccentColor: string = this.props.accentColor || 'eskogreen';
    if (oldAccentColor !== newAccentColor) {
      if (oldAccentColor !== 'eskogreen') {
        $('body').removeClass('esko_accentcolor_' + oldAccentColor);
      }
      if (newAccentColor !== 'eskogreen') {
        $('body').addClass('esko_accentcolor_' + newAccentColor);
      }
    }
  }

  override render (): React.ReactNode {
    const { children } = this.props;

    return (
      <div className='esko_root'>
        {children}
      </div>
    );
  }
}

export default Root;
